/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

'use strict';

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var matchersTransform = require('../transforms/matchers');
var treatmentsParser = require('../treatments').parse;
var matcherFactory = require('../matchers');
var sanitizeValue = require('../value');
var evaluatorFactory = require('../evaluator');
var ifElseIfCombiner = require('../combiners/ifelseif');
var andCombiner = require('../combiners/and');
var thenable = require('../../utils/promise/thenable');

function parse(conditions, storage) {
  var predicates = [];

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(conditions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var condition = _step.value;
      var matchers = condition.matcherGroup.matchers,
          partitions = condition.partitions,
          label = condition.label,
          conditionType = condition.conditionType;

      // transform data structure

      matchers = matchersTransform(matchers);

      // create a set of pure functions from the matcher's dto
      var expressions = matchers.map(function (matcherDto) {
        var matcher = matcherFactory(matcherDto, storage);

        return function (key, attributes) {
          var value = sanitizeValue(key, matcherDto, attributes);
          var result = value !== undefined ? matcher(value) : false;

          if (thenable(result)) {
            return result.then(function (res) {
              return Boolean(res ^ matcherDto.negate);
            });
          }
          return Boolean(result ^ matcherDto.negate);
        };
      });

      // if matcher's factory can't instanciate the matchers, the expressions array
      // will be empty
      if (expressions.length === 0) {
        // reset any data collected during parsing
        predicates = [];
        // and break the loop
        break;
      }

      predicates.push(evaluatorFactory(andCombiner(expressions), treatmentsParser(partitions), label, conditionType));
    }

    // Instanciate evaluator given the set of conditions using if else if logic
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return ifElseIfCombiner(predicates);
}

module.exports = parse;


//////////////////
// WEBPACK FOOTER
// ../~/@splitsoftware/splitio/lib/engine/parser/index.js
// module id = 1199
// module chunks = 0